(function () {
  'use strict';

  var btn = document.querySelector('[data-czard-sound]');
  var audio = document.querySelector('[data-czard-sound-audio]');
  if (!btn || !audio) return;

  // Rendered hidden so it never flashes on a browser that cannot play it.
  if (!audio.canPlayType || !audio.canPlayType('audio/mpeg')) return;
  btn.hidden = false;

  var STATE_KEY = 'czard_sound';
  var TIME_KEY = 'czard_sound_t';
  var VOLUME = 0.35;

  audio.volume = VOLUME;

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function paint(playing) {
    btn.classList.toggle('is-playing', playing);
    btn.setAttribute('aria-pressed', String(playing));
    btn.setAttribute('aria-label', playing ? 'Pause ambient sound' : 'Play ambient sound');
  }

  // onBlocked, when given, takes over the refusal case instead of recording a
  // deliberate "off" — used by the autoplay attempt, which is blocked by
  // policy rather than declined by the visitor.
  function play(onBlocked) {
    var at = parseFloat(read(TIME_KEY));
    if (at > 0 && isFinite(at)) {
      // Only safe once there is enough metadata to seek.
      var seek = function () {
        try { if (at < audio.duration) audio.currentTime = at; } catch (e) {}
      };
      if (audio.readyState >= 1) seek();
      else audio.addEventListener('loadedmetadata', seek, { once: true });
    }

    var p = audio.play();
    if (p && p.catch) {
      // Autoplay policy can refuse this on a fresh page load with no gesture
      // yet. Fall back to the paused state rather than showing it as playing.
      p.then(function () {
        store(STATE_KEY, 'on');
        paint(true);
      }).catch(function () {
        paint(false);
        if (onBlocked) onBlocked();
        else store(STATE_KEY, 'off');
      });
    } else {
      store(STATE_KEY, 'on');
      paint(true);
    }
  }

  function pause() {
    audio.pause();
    store(STATE_KEY, 'off');
    store(TIME_KEY, audio.currentTime);
    paint(false);
  }

  btn.addEventListener('click', function () {
    if (audio.paused) play();
    else pause();
  });

  audio.addEventListener('play', function () { paint(true); });
  audio.addEventListener('pause', function () { paint(false); });

  // Remember where the track was so it carries across page loads rather than
  // restarting — this is a multi-page site, so each navigation is a fresh
  // element.
  audio.addEventListener('timeupdate', function () {
    if (!audio.paused) store(TIME_KEY, audio.currentTime);
  });
  window.addEventListener('pagehide', function () {
    if (!audio.paused) store(TIME_KEY, audio.currentTime);
  });

  // ---- autoplay ----
  // On by default: a visitor with no stored preference gets sound. Once they
  // press pause that choice is remembered for the session and respected.
  //
  // Browsers will not let audible media start without a user gesture, so the
  // opening play() is refused on a cold first load however it is written.
  // Rather than give up there, the first interaction anywhere on the page is
  // used to start it — which is the earliest moment the browser allows.
  var stored = read(STATE_KEY);
  var wantsSound = stored === null ? true : stored === 'on';

  var GESTURES = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
  var armed = false;

  function onFirstGesture(e) {
    // The toggle speaks for itself — let its own handler decide.
    if (btn.contains(e.target)) { disarm(); return; }
    disarm();
    if (read(STATE_KEY) !== 'off') play();
  }

  function disarm() {
    if (!armed) return;
    armed = false;
    for (var i = 0; i < GESTURES.length; i++) {
      window.removeEventListener(GESTURES[i], onFirstGesture, true);
    }
  }

  function arm() {
    if (armed) return;
    armed = true;
    for (var i = 0; i < GESTURES.length; i++) {
      window.addEventListener(GESTURES[i], onFirstGesture, { capture: true, passive: true });
    }
  }

  // arm() rather than a stored "off": the refusal is the browser's, not the
  // visitor's, so the intent to play survives until the first gesture.
  if (wantsSound) play(arm);
  else paint(false);
})();
